import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
/**
 * Light wrapper for "label + control" pairs.
 * - Label: 14px / 400 / 16lh, text-primary
 * - Gap between label and control: 4px
 */
export function FormField({ label, htmlFor, required = false, className, labelClassName, children, }) {
    return (_jsxs("div", { className: cn("flex flex-col gap-1", className), children: [_jsxs(Label, { htmlFor: htmlFor, className: cn("f-14-400-16 text-text-primary", labelClassName), children: [label, " ", required ? (_jsx("span", { className: "text-text-error", "aria-hidden": "true", children: "*" })) : null] }), children] }));
}
